/**
 * Integration links are stored Show-agnostic: the editor writes `__show__` and
 * `useRedirectToExternalLink` resolves it against the Show being read. The token
 * cannot collide with a uuid and needs no escaping.
 */
export const EXTERNAL_REDIRECT_SHOW_TOKEN = "__show__";

/** Relative on purpose — an absolute link would bake in the authoring origin. */
export const EXTERNAL_REDIRECT_PLACEHOLDER_PATH = `/shows/${EXTERNAL_REDIRECT_SHOW_TOKEN}/external-redirect`;

/** The href the toolbar inserts for one integration. */
export const externalRedirectPlaceholderHref = (type: string): string =>
  `${EXTERNAL_REDIRECT_PLACEHOLDER_PATH}?type=${type}`;

/** An integration link: the placeholder, one baked with a Show id, or the legacy ASP path. */
export const isExternalRedirectHref = (href: string): boolean =>
  /^\/shows\/[^/]+\/(?:external-redirect\?|redirect-to-asp$)/.test(href);
